import { AnyAction } from 'redux';
import * as actionTypes from '../actions/actionTypes';

export interface IRules {
  account_id: string;
  /**
   * Call direction |inbound | outbound | both
   */
  direction: string;
  /**
   * Rule ID
   */
  id: number;
  /**
   * Min words in notes
   */
  notes: number;
  /**
   * Extension number
   */
  number: string[];
  /**
   * List of queueId. The queueId can be retrieved from sip header 'X-Nuacom-QueueID'
   * Change `any[]` to the appropriate type if necessary
   */
  queue_id: any[];
  /**
   * Min words in tags
   */
  tags: number;
  /**
   *   Timer (in minutes):
   */
  timer: number;
}

export interface ICallTaggingInfo {
  callId: string;
  contactName: string;
  numberFrom: string | number;
  direction: 'outbound' | 'inbound';
  directionNumber: number;
  queueId: string | null;
  outboundCli: string;
  rules: IRules;
}

interface IAfterCallState {
  loading: boolean;
  /**
   * Contains the list of rules setting fetched from web portal API
   */
  rules: IRules[];
  /**
   * Contains the mandatory call rules for a given call info.
   * The MandatoryCallTagging component is watch for mandatoryCallTagging array, once it changes the dialog is displayed for the user's
   */
  mandatoryCallTagging: ICallTaggingInfo[];
  /**
   * This is a mandatory busy state, it should be set true when dialog is displayed
   * Also, this is a way to avoid multiple register/unregister
   */
  busyState: boolean;
}

const initialState: IAfterCallState = {
  loading: false,
  rules: [],
  mandatoryCallTagging: [],
  busyState: false,
};

const afterCallWork = (
  state: IAfterCallState = initialState,
  action: AnyAction
): IAfterCallState => {
  switch (action.type) {
    case actionTypes.STORE_AFTER_CALL_RULES:
      return {
        ...state,
        rules: action.payload,
      };
    case actionTypes.STORE_MANDATORY_CALL_TAGGNING_INFO:
      return {
        ...state,
        mandatoryCallTagging: [...state.mandatoryCallTagging, action.payload],
      };
    case actionTypes.MANDATORY_BUSY_STATE_CHANGE:
      return {
        ...state,
        busyState: action.payload,
      };
    case actionTypes.EXPIRED_OR_SUCCESS_MANDATORY_CALL_TAGGNING:
      return {
        ...state,
        mandatoryCallTagging: state.mandatoryCallTagging.filter(
          e => e.callId !== action.payload.callId
        ),
      };
    default:
      return {
        ...state,
      };
  }
};

export default afterCallWork;
